//const baseURLApi = 'http://localhost:5071';
const baseURLApi = 'https://api.antique-watches.de';

export default {
  baseURLApi,
  api: {
    url: `${baseURLApi}/api`,
  }
};
